import type { FC } from 'react';
import type { RealizedAndImpliedVolsProps } from './types';
import RealizedAndImpliedVolsWidget from './realized-and-implied-vols-widget';

import { TokenVolatilityTimeseriesProvider } from '../../../../providers/token-volatility-timeseries-provider';

const RealizedAndImpliedVolsWrapperProvider: FC<RealizedAndImpliedVolsProps> = (props) => (
  <TokenVolatilityTimeseriesProvider providerKey={props.providerKey}>
    <RealizedAndImpliedVolsWidget {...props} />
  </TokenVolatilityTimeseriesProvider>
);

export default RealizedAndImpliedVolsWrapperProvider;
